module.exports = __webpack_public_path__ + "media/property-types/Standalone_House-3f6f6627.png";